"use client";

import Image from "next/image";
import { PageWrapper } from "@/components/core";

import "@/styles/globals.css";

// The root layout is a pass-through — the `<html>` shell lives in
// `[locale]/layout`. This not-found boundary is reached for fully unmatched
// paths and for an invalid `[locale]` segment (where `[locale]/layout` throws
// `notFound()` before rendering its own `<html>`), so it must supply its own
// document shell + stylesheet. Locale is unknown here, so default to fa/rtl.
//
// NOTE: Strings are intentionally kept as hardcoded Persian (not extracted to
// the `errors` catalog). This component renders outside any `[locale]` segment,
// so there is no NextIntlClientProvider or locale context available — calling
// `useTranslations` / `getTranslations` here would throw at runtime.
// Real per-locale 404s are handled by `src/app/[locale]/not-found.tsx` which
// has full i18n context; this boundary is only hit for invalid locale segments.
export default function NotFound() {
  return (
    <html lang="fa" dir="rtl" className="dark">
      <body className="antialiased bg-background">
        <main className="bg-bg-primary">
          <PageWrapper>
            <div className="flex flex-col items-center justify-center min-h-[60vh] text-center space-y-6">
              <Image
                src="/images/ui/not-found.webp"
                alt="not-found"
                width={100}
                height={100}
              />
              <h2 className="text-2xl font-semibold text-text-primary">
                صفحه مورد نظر یافت نشد
              </h2>
            </div>
          </PageWrapper>
        </main>
      </body>
    </html>
  );
}
